module.exports = __webpack_public_path__ + "img/section-number-delivery-outline.4bf12582.svg";